export class FilterResponse {
    constructor(type, name, inputType, displayOrder, filters) {
        this.type = type
        this.name = name
        this.inputType = inputType
        this.displayOrder = displayOrder
        this.filters = filters
    }
}
